import styled from 'styled-components';

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const ListContainer = styled.div`
  width: 97%;
  margin: auto auto;
`;

const ChartsContainer = styled.div`
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  @media (min-width: 1390px) {
    flex-direction: row;
  }
`;

const FullScreen = styled.div`
  height: 100vh;
  width: 100vw;
  position: fixed;
  left: 0;
  top: 0;
  background: white;
`;

export default {
  PageContainer,
  ChartsContainer,
  ListContainer,
  FullScreen,
};
